import React,{useEffect} from 'react';
import { Table } from 'react-bootstrap';
import { Container, Row, Col } from 'react-bootstrap';
import { materialData } from '../../ProData';

const TablesMaterials = () => {

  useEffect(() => {
    document.title = "Materials - Jesuit Madurai Province Archives (JEMPARC)";  
    window.scrollTo(0, 0);
    document.body.classList.add('materials');
  }, []);

  return (
     <div>
      <section id="about" className="about section">
      <div className="container section-title" data-aos="fade-up">
          <h2>Materials</h2>
          <p>List of Documents / Books</p>
        </div>
    <Container>
    <Table striped responsive bordered hover>
      <thead>
        <tr>
          <th>S.No</th>
          <th>Documents / Books</th>
        </tr>
      </thead>
      <tbody>
      {materialData.length>0 && materialData.map((material, index)=>{
        return (
        <tr key={index}>
<td  >{material.id}</td>

<td style={{ textAlign: 'left', paddingLeft:"30px" }}>{material.books}</td>
</tr>)})}

      </tbody>
    </Table>
    </Container>
    </section>
    </div>
  );
}

export default TablesMaterials;